import { useState } from "react";
import SectionHeader from "./SectionHeader";

const faqs = [
  {
    q: "「反差黑料人物」到底是谁？为什么大家都在问",
    a: "在现有公开讨论里，「反差黑料人物」并非特指某位可实名确认的个体，而是被反复用来代称以「幕布」为核心、可能牵出多名当事人的一组身份。目前主角与关联账号之间的归属仍未获得独立佐证，所以问题依旧开放，这也正是持续扒皮追踪的焦点。",
  },
  {
    q: "「反差黑料主角」和「反差黑料当事人」有什么区别？",
    a: "主角指被反复指向的核心运营者「幕布」；当事人指因同一事件被卷入讨论、并先后发声的「L」「对照相」等关联方。主角是争议的起点，当事人让争议从单点变成关系网。",
  },
  {
    q: "这里的「反差黑料扒皮」信息都可靠吗？",
    a: "本页仅对公开渠道出现过的线索做交叉归置，聊天记录原始性、账号归属等关键证据尚未被第三方独立核验。凡是未实锤的判断，我们都明确标为「待证」或「存疑」，不把猜测写成结论。",
  },
  {
    q: "既然还不确定，为什么会有这么多反差黑料身份猜想？",
    a: "因为当事人各自口径在关键时间点上彼此冲突，而冲突本身没有硬证据收敛。只要关系线无法闭合，围绕「反差黑料是谁」的多套猜想就会并存，直到有可独立核验的材料出现。",
  },
  {
    q: "后续怎么跟上这件事的最新进展？",
    a: "本专题会随公开信息演进持续更新时间线与疑点状态。你可以在下方登记追踪提醒（当前为静态展示），或回到话题墙按感兴趣的分类自行跟进。",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeader
              kicker="PART 06 · 网友FAQ"
              title="被问得最多的几个问题"
              desc="把新手最容易卡住的疑问集中讲清楚。FAQ 内容与前面模块互为印证，便于一次读懂反差黑料人物的来龙去脉。"
            />
            <div className="hidden lg:block rounded-xl border border-background-200 bg-background-50 p-5">
              <p className="flex items-start gap-2 text-xs leading-6 text-foreground-500">
                <i className="ri-information-line text-primary-500 w-4 h-4 flex items-center justify-center mt-0.5 shrink-0" />
                任何结论请以可核验的原始材料为准，本页仅做信息整合与状态标注。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqs.map((f, idx) => {
              const active = open === idx;
              return (
                <div
                  key={f.q}
                  className={`rounded-xl border bg-background-50 transition-colors ${
                    active ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    onClick={() => setOpen(active ? -1 : idx)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    aria-expanded={active}
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-900 leading-6">
                      {f.q}
                    </span>
                    <i
                      className={`${
                        active ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-400"
                      } w-5 h-5 shrink-0 flex items-center justify-center text-lg transition-colors`}
                    />
                  </button>
                  {active ? (
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{f.a}</p>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}